/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { report } from './report';

export class reportindex extends report {
  report_index_key: string = "";

  public gettablename(): string {
    return "REPORT_INDEX";
  }
}
